import { validateStringInput, validateViewProperties } from '../utils/formValidationHelpers';
import { ViewProperty } from './ViewProperty';

export enum ViewStyle {
    table = 0,
    list = 1,
    grid = 2,
}

export type View = {
    viewId: number;
    clientId: number | null;
    userName: string;
    name: string;
    style: ViewStyle;
    properties: ViewProperty[];
};

export type CreateViewRequest = {
    viewId?: number;
    name: string;
    style: ViewStyle;
    properties: ViewProperty[];
};

/**
 * buildCreateView
 *
 * @description
 * Builds an object matching the structure expected by the server in a request to
 * create a new custom view
 */
export function buildCreateView(args: {
    viewId?: number;
    name: string;
    style: ViewStyle;
    properties: ViewProperty[];
}): CreateViewRequest {
    return {
        viewId: args.viewId,
        name: validateStringInput('name', args.name),
        style: args.style,
        properties: validateViewProperties(args.properties),
    };
}

export type UpdateViewRequest = {
    viewId: number;
    clientId: number | null;
    userName: string;
    name: string;
    style: ViewStyle;
    properties: ViewProperty[];
};

/**
 * buildUpdateView
 *
 * @description
 * Builds an object matching the structure expected by the server in a request to
 * update an existing custom view
 */
export function buildUpdateView(args: View): UpdateViewRequest {
    return {
        viewId: args.viewId,
        clientId: args.clientId,
        userName: args.userName,
        name: validateStringInput('name', args.name),
        style: args.style,
        properties: validateViewProperties(args.properties),
    };
}
